// src/styles/theme.js
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import palette from "./palette";
import typography from "./typography";
import components from "./components";
import custom from "./custom";

const getTheme = () => {
  // Create base theme
  let theme = createTheme({
    palette,
    typography,
    shape: {
      borderRadius: 8,
      borderRadiusSmall: 4,
      borderRadiusLarge: 12,
      borderRadiusXLarge: 16,
    },
    spacing: 8,
    components,
    custom,
  });

  // Apply responsive font sizes
  theme = responsiveFontSizes(theme, { factor: 2 });
  
  return theme;
};

export default getTheme; // ✅ Export as function